<div class="columns is-marginless is-centered is-full-height is-vcentered">
    <div class="column is-half">
        <div class="is-size-4 has-text-centered">
            <img src="logo192.png"><br>
            fairball!
        </div>
        <div class="field">
            <p class="control has-icons-left">
                <input class="input" type="text" placeholder="Verification code" bind:value=code>
                <span class="icon is-small is-left">
                    <i class="fas fa-user-check"></i>
                </span>
            </p>
        </div>
        <div class="field is-grouped is-grouped-centered">
            <p class="control">
                <button class="button is-primary {loading ? 'is-loading':''}" on:click="verifyCode()">
                    Verify
                </button>
            </p>
        </div>
        <div class="notification is-success {alert ? 'is-hidden': ''}">
            <button class="delete"></button>
            Check your email for a verification code and enter it here
        </div>
        <div class="notification is-danger {alert ? '': 'is-hidden'}">
            <button class="delete" on:click='set({alert: false})'></button>
            The verification code you entered was incorrect.  Maybe there was a typo?
        </div>
    </div>
</div>

<script>
    export default {
        data() {
            return {
                code: "",
                loading: false,
                alert: false
            }
        },
        methods: {
            async verifyCode(ev) {
                this.set({loading: true});
                const { code } = this.get();
                const { email, server } = this.store.get();
                const res = await fetch(server + '/verify?email=' + email + '&code=' + code);
                const resMsg = await res.json();

                if (resMsg.success) {
                    this.store.set({ token: resMsg.token });
                    window.location.reload();
                } else {
                    this.set({loading: false, alert: true, code: ""});
                }
            }
        }
    };
</script>